import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import env from './environments/environment'
import { TrackJS } from 'trackjs'
import UserProfileService from './shared/services/UserProfile.service'
import registerServiceWorker from './registerServiceWorker'
import packageJson from '../package.json'

import '@fortawesome/fontawesome-free/css/all.min.css'
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import './index.scss'

// Set the application version for global access.
// global.appVersion = `${process.env.REACT_APP_VERSION}`
global.appVersion = packageJson.version

// QA/dev only: simulate an out-of-date ("stale bundle") client without a
// rebuild — append ?qa_app_version=1.9.3 to the URL so the version check sees
// running < available and engages the update paths (auto-reload / "Update My
// Backoffice"). Read from the QUERY STRING, not localStorage, so it self-clears
// the moment you navigate away — no sticky state to forget. It still survives
// full-page reloads (so the reload-loop test works), logs a loud warning while
// active, and is hard-gated to the local env so it can never run in beta/prod.
// See scripts/version/README.md.
try {
  if (env && env.env === 'local') {
    const qaVersion = new URLSearchParams(window.location.search).get('qa_app_version')
    if (qaVersion) {
      global.appVersion = qaVersion
      console.warn(
        `[qa] Version override ACTIVE — reporting "${qaVersion}" instead of the ` +
          `real "${packageJson.version}". Drop ?qa_app_version from the URL to clear.`
      )
    }
  }
} catch (e) {}

// Instruct React to build the DOM
const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript
root.render(<App />)

// Enable TrackJS monitoring if identified in env
if (env?.integrations?.track_js) {
  let trackJsConfig = {
      ...env.integrations.track_js,
      version: global.appVersion,
    },
    userId = UserProfileService.getUserId(true)
  if (!isNaN(userId) && userId !== null) trackJsConfig.userId = userId.toString()
  TrackJS.install(trackJsConfig)
}

// Register application service worker (CacheBustin)
registerServiceWorker()
